import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, InputLabel, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme)=> ({
    dialogPaper: {
        minHeight: '80vh'
    }
}))


function PaperComponent(props) {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
}
  
export default function OrderDetail(props) {

    const classes = useStyles();
    const {t} = useTranslation('common');
    const dispatch = useDispatch();

    const { openModal, unitSN, data, onClose} = props;

    let keys = Object.keys(data);


    const array = [];
    const subKeys = [];
    for (let i=0,j=0; j < keys.length; i=i+1,j=j+8) {
        let obj = {};
        obj[keys[j]] = data[keys[j]];
        if ((j+1) < keys.length) obj[keys[j+1]] = data[keys[j+1]];
        if ((j+2) < keys.length) obj[keys[j+2]] = data[keys[j+2]];
        if ((j+3) < keys.length) obj[keys[j+3]] = data[keys[j+3]];
        if ((j+4) < keys.length) obj[keys[j+4]] = data[keys[j+4]];
        if ((j+5) < keys.length) obj[keys[j+5]] = data[keys[j+5]];
        if ((j+6) < keys.length) obj[keys[j+6]] = data[keys[j+6]];
        if ((j+7) < keys.length) obj[keys[j+7]] = data[keys[j+7]];

        array[i] = obj;
        subKeys[i] = Object.keys(obj);
    }    
    
       
    return (        
            <Dialog 
                open={openModal}
                onClose={handleClose} 
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth='xl'
                scroll='body'
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Order Detail : {unitSN}
                    <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Tooltip>        
                </DialogTitle>
                <DialogContent dividers>
                {                    
                    array.map((item,index)=>(
                        <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}} key={item}>
                            {subKeys[index].map((ele,idx)=>(
                                <TextField
                                id={ele}
                                label={ele}
                                InputLabelProps={{ shrink: true }}                                
                                type="string"
                                variant="outlined"
                                value={item[subKeys[index][idx]]}
                                disabled={true}
                                style={{width: 200, paddingRight: 20}}
                            />                                
                                // <div key={ele}>
                                // <InputLabel style={{width: 100, padding: 10}}>{ele}:</InputLabel> {item.ele}
                                // <InputLabel style={{width: 100, padding: 10}}>{item[subKeys[index][idx]]}</InputLabel>
                                // </div>
                            ))}                            
                        </div>
                    )

                    )
                }

                </DialogContent>  
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="primary">
                        Close
                    </Button>
                    </DialogActions>                          
            </Dialog>
    )

    /**
     * Close the MessageSnackbar
     * Call the prarent function to handle the status after this dialoge is closed
     */
    function handleClose() {    
        onClose();
    };

}

